// extracted by mini-css-extract-plugin
export default {"header":"HeaderTitle_header__CM7+j","bookingHistoryHeader":"HeaderTitle_bookingHistoryHeader__FiVaw","backButton":"HeaderTitle_backButton__JHVtT","title":"HeaderTitle_title__gn6b-"};